import { render, staticRenderFns } from "./GenericOrderComponents.vue?vue&type=template&id=f2f7fa6a"
import script from "./GenericOrderComponents.vue?vue&type=script&lang=js"
export * from "./GenericOrderComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports